module.exports = __webpack_public_path__ + "img/tools.6b8e98d4.png";